/**
 * Operator-facing language for the first confirmed documents in a job.
 *
 * A Content Central-backed job already has its document types and fields. What
 * is young is Paige's recognition evidence for those definitions. Keep
 * that distinction in one place so the progress strip, live workbench, and
 * document spine cannot each tell a different story about the same work.
 */
export type CaptureLearningLanguage = {
  phaseLabel: string;
  activeDescription: string;
  discoveryLabel: string;
  intelligenceTitle: string;
  pendingTypeLabel: string;
  understandingInsight: string;
  finalizingInsight: string;
  earlyChipLabel: string;
  earlyChipTitle: string;
};

export const captureLearningLanguage = (
  catalogBacked: boolean,
  verifiedDocuments: number,
): CaptureLearningLanguage => {
  const early = verifiedDocuments < 10;
  if (catalogBacked) {
    return {
      phaseLabel: early ? 'Learning catalog documents' : 'Reading new pages',
      activeDescription:
        'The catalog already defines the types and fields. Confirmed documents teach Paige how to recognize them and read their values.',
      discoveryLabel: 'Catalog types matched',
      intelligenceTitle: 'Catalog types in these pages',
      pendingTypeLabel: 'Catalog matches will appear here',
      understandingInsight: 'Matching page evidence to the catalog’s existing types and fields',
      finalizingInsight: 'Saving completed documents with the catalog setup',
      earlyChipLabel: 'Catalog setup loaded',
      earlyChipTitle:
        'The types and fields came from Content Central. Confirmed documents teach Paige how to recognize those types and read their values.',
    };
  }

  return {
    phaseLabel: early ? 'Early learning' : 'Reading new pages',
    activeDescription: 'Every source enters the same document stream.',
    discoveryLabel: 'Patterns taking shape',
    intelligenceTitle: 'What Paige is learning',
    pendingTypeLabel: 'Reusable patterns will appear here',
    understandingInsight:
      'Matching visual and textual evidence into reusable document types and fields',
    finalizingInsight: 'Saving the document types and fields for this job',
    earlyChipLabel: 'Early learning',
    earlyChipTitle:
      'This job is new to me. The first documents ask the most questions - each one you confirm teaches the rest, and the questions drop quickly.',
  };
};
